"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

// crop max and max aspect for express-editor
var MAX_DESIRED_RATIO = 2.0; // max aspect 2.0 for landscape

var MIN_DESIRED_RATIO = 1.0; // min aspect 1.0 (square)

var AMCore = new function () {
  var _this = this;

  var deCamelRegEx = new RegExp('([A-Z])', 'g');

  var deCamelFunc = function deCamelFunc(a) {
    return '-' + a.toLowerCase();
  };

  this.svgNs = 'http://www.w3.org/2000/svg';

  this.setCrossBrowserStyle = function (element, style) {
    for (var key in style) {
      var csskey = key.replace(deCamelRegEx, deCamelFunc);
      element.style[csskey] = style[key];
      element.style['-webkit-' + csskey] = style[key];
    }
  };

  this.setTransform = function (el, transform) {
    return _this.setCrossBrowserStyle(el, {
      transform: transform
    });
  };

  this.setTransformOrigin = function (el, transform) {
    return _this.setCrossBrowserStyle(el, {
      transformOrigin: transform
    });
  };

  this.setTransition = function (el, transition) {
    return _this.setCrossBrowserStyle(el, {
      transition: transition
    });
  };

  var urlSplitRegEx = new RegExp('^(https?:|)\\/\\/([^\\:\\/\\?#]+)\\:?(\\d*)', 'i');

  this.isCrossOriginURL = function (url) {
    var parts = url.match(urlSplitRegEx);

    if (parts && (parts[1] !== '' && parts[1] !== window.location.protocol || parts[2] !== window.location.hostname || parts[3] !== window.location.port)) {
      return true;
    }

    return false;
  };

  this.hide = function (el) {
    if (el.amhide) {
      el.amhide();
    } else if (el.classList) {
      // SVG has no claslist in ie
      el.classList.add('amhidden');
    } else {
      var old = el.getAttribute('class') || '';

      if (old.indexOf('amhidden') === -1) {
        // TODO: whole words regex
        old += ' amhidden';
      }

      el.setAttribute('class', old.trim());
    }
  };

  this.nop = function (_) {};
}();
var AMConfig = {
  cssvars: {
    colors: {
      back1: 'white',
      back2: '#f0f0f0',
      front1: 'black',
      front2: '#00BCD4'
    }
  }
};

function svgEl(type, name, value) {
  var el = document.createElementNS(AMCore.svgNs, type);

  for (var i = 1; i < arguments.length; i += 2) {
    if (arguments[i] === '_child') {
      el.appendChild(arguments[i + 1]);
    } else {
      el.setAttributeNS(null, arguments[i], arguments[i + 1]);
    }
  }

  return el;
}

function svgAttr(el, name, value) {
  for (var i = 1; i < arguments.length; i += 2) {
    el.setAttributeNS(null, arguments[i], arguments[i + 1]);
  }
}

var requestAnimationFrame = typeof window !== 'undefined' && window.requestAnimationFrame;

var AMCropperParams = /*#__PURE__*/function () {
  function AMCropperParams(cropParams) {
    var _this2 = this;

    (0, _classCallCheck2["default"])(this, AMCropperParams);

    this.getPositionInfo = function () {
      var cropWidth = 1.0 / _this2.cropScale;
      var cropheight = 1.0 / _this2.cropScale * _this2.cropAspect;
      return {
        focusPoint: {
          x: _this2.cropX + cropWidth * 0.5,
          y: _this2.cropY + cropheight * 0.5
        },
        scale: _this2.cropScale
      };
    };

    this.setCropInfo = function (info, width, height) {
      _this2.cropAspect = width / height;
      _this2.fixedAspect = width / height;
      _this2.autoCenter = false;
      _this2.autoAspect = false;
      var crop = info.rect;

      if (!crop) {
        crop = {
          x: 0,
          y: 0,
          width: 1,
          height: 1
        };
      }

      _this2.imageAspect = info.imageSize.width / info.imageSize.height;

      if (crop.width * info.imageSize.width / width < crop.height * info.imageSize.height / height) {
        _this2.cropScale = 1 / crop.width;
        _this2.cropX = crop.x;
        _this2.cropY = crop.y / _this2.imageAspect;
        var yScale = _this2.cropScale / _this2.imageAspect * _this2.cropAspect;
        _this2.cropY += (crop.height - 1 / yScale) * (info.offsetY !== undefined ? info.offsetY : 0.5) / _this2.imageAspect;
      } else {
        var _yScale = 1 / crop.height;

        _this2.cropScale = _yScale / _this2.cropAspect * _this2.imageAspect;
        _this2.cropX = crop.x;
        _this2.cropX += (crop.width - 1 / _this2.cropScale) * (info.offsetX !== undefined ? info.offsetX : 0.5);
        _this2.cropY = crop.y / _this2.imageAspect;
      }
    };

    this.minScale = 1.0;
    this.maxScale = 10.0;
    this.cropCircle = false;
    this.freeRotate = true;
    this.fixedAspect = -1;
    this.autoCenter = true;
    this.autoAspect = false;
    this.minAspectScale = 1.0; // Calculated minScale based on aspect ratio

    this.cropX = 0.0;
    this.cropY = 0.0;
    this.cropScale = 1.0;
    this.cropAspect = 1.0;
    this.cropAngle = 0;
    this.backContent = null;
    this.backX = 0.0;
    this.backY = 0.0;
    this.backScale = 1.0;
    this.backAspect = 1.0;
    this.imageAspect = 1.0;

    if (cropParams) {
      this.autoCenter = !Object.hasOwnProperty.call(cropParams, 'cropX') || !Object.hasOwnProperty.call(cropParams, 'cropY');

      for (var k in cropParams) {
        this[k] = cropParams[k];
      }
    }

    if (isNaN(this.fixedAspect)) this.fixedAspect = -1.0;

    if (isNaN(this.cropAspect)) {
      this.cropAspect = 1.0;
      this.autoAspect = true;
    }
  } // Function for express editor, converting a position record to crop info


  (0, _createClass2["default"])(AMCropperParams, [{
    key: "updateRestrictions",
    value: function updateRestrictions() {
      if (this.fixedAspect !== -1) {
        this.cropAspect = this.fixedAspect;
        this.autoAspect = false;
      }

      if (this.autoAspect) {
        this.cropAspect = this.imageAspect;
        this.autoAspect = false;
      }

      if (this.cropCircle) {
        this.cropAspect = 1.0;
      }

      var imageAspect = this.imageAspect;
      var cropAspect = this.cropAspect; // var diagonalScale = Math.sqrt(1 + imageAspect * imageAspect);

      var angleRAD = this.cropAngle / 180 * Math.PI;
      var sin = Math.sin(angleRAD);
      var cos = Math.cos(angleRAD);
      var absSin = Math.abs(sin);
      var absCos = Math.abs(cos);
      var minAspectScale1 = absCos * imageAspect + absSin;
      var minAspectScale2 = absCos + imageAspect * absSin;
      imageAspect = minAspectScale1 / minAspectScale2;
      var imgHeightPerc = 1.0 / this.imageAspect;
      var leftBottomX = -imgHeightPerc * sin;
      var leftBottomY = imgHeightPerc * cos;
      var rightBottomX = -imgHeightPerc * sin + cos;
      var rightBottomY = imgHeightPerc * cos + sin;
      var rightTopX = cos;
      var rightTopY = sin;
      var maxWidth = Math.max(Math.abs(leftBottomX - rightTopX), Math.abs(rightBottomX));
      var maxHeight = Math.max(Math.abs(leftBottomY - rightTopY), Math.abs(rightBottomY));
      var extraScale = (1 / this.minScale - 1.0) / 2.0;
      var minX = -extraScale * maxWidth;
      var minY = minX * maxHeight * imageAspect / cropAspect;
      minX /= this.cropScale;
      minY /= this.cropScale;
      maxWidth /= this.minScale;
      maxHeight /= this.minScale;
      var marginX = Math.min(0, leftBottomX, rightBottomX, rightTopX);
      var marginY = Math.min(0, leftBottomY, rightBottomY, rightTopY);
      minX = Math.min(minX, marginX);
      minY = Math.min(minY, marginY);
      this.cropScale = Math.min(this.cropScale, this.maxScale);
      this.minAspectScale = Math.max(1 / (maxHeight * cropAspect), 1 / maxWidth);
      this.cropScale = Math.max(this.cropScale, this.minAspectScale);

      if (this.autoCenter) {
        this.cropY = 0.5 * (imgHeightPerc - 1 / (this.cropScale * cropAspect));
        this.cropX = 0.5 - 0.5 / this.cropScale;
        this.autoCenter = false;
      }

      var maxX = marginX + maxWidth - 1 / this.cropScale;
      var maxY = marginY + maxHeight - 1 / (this.cropScale * cropAspect);
      maxX = (maxX + extraScale / this.cropScale) * this.minScale;
      maxY = (maxY + extraScale / (this.cropScale * cropAspect)) * this.minScale;
      this.cropX = Math.min(Math.max(this.cropX, minX), maxX);
      this.cropY = Math.min(Math.max(this.cropY, minY), maxY);
    }
  }, {
    key: "calcCropInfo",
    value: function calcCropInfo(maxDesiredRatio, minDesiredRadio) {
      if (this.cropX === undefined || !this.loadedImage) {
        return {
          offsetX: 0.5,
          offsetY: 0.5
        };
      }

      var yScale = this.cropScale / this.imageAspect * this.cropAspect;
      var maxGrowX = Math.min(maxDesiredRatio, this.cropScale * this.cropAspect) - this.cropAspect;
      var maxGrowY = (Math.min(this.cropAspect / minDesiredRadio, yScale) - 1) * this.cropAspect;
      var cropYConv = this.cropY * this.imageAspect;

      var equals = function equals(a, b) {
        return Math.abs(a - b) < 0.00001;
      };

      var isEmptyCrop = function isEmptyCrop(rect) {
        return equals(rect.x, 0) && equals(rect.y, 0) && equals(rect.width, 1) && equals(rect.height, 1);
      };

      var cropInfo = {};
      var rect;

      if (maxGrowX > maxGrowY) {
        // crop landscape
        var invCropScale = 1 / this.cropScale;
        var maxCropScale = invCropScale / this.cropAspect * maxDesiredRatio; // max aspect 2.0 for landscape

        var newCropScaleX = Math.min(1, Math.max(invCropScale, maxCropScale)); // cut out widest image possible

        var offset = (newCropScaleX - invCropScale) * 0.5;
        var newCropX = Math.max(0, this.cropX - offset);
        newCropX -= Math.max(0, newCropX + newCropScaleX - 1);

        if (offset > 0) {
          cropInfo.offsetX = Math.abs(this.cropX - newCropX) / (offset * 2);
        }

        rect = {
          x: newCropX,
          y: cropYConv,
          width: newCropScaleX,
          height: 1 / yScale
        };
      } else {
        // crop portrait
        var _invCropScale = 1 / yScale;

        var newCropScaleY = Math.min(1, _invCropScale * this.cropAspect / minDesiredRadio);

        var _offset = (newCropScaleY - _invCropScale) * 0.5;

        var newCropY = Math.max(0, cropYConv - _offset);
        newCropY -= Math.max(0, newCropY + newCropScaleY - 1);

        if (_offset > 0) {
          cropInfo.offsetY = Math.abs(cropYConv - newCropY) / (_offset * 2);
        }

        rect = {
          x: this.cropX,
          y: newCropY,
          width: 1 / this.cropScale,
          height: newCropScaleY
        };
      }

      if (!isEmptyCrop(rect)) {
        cropInfo.rect = rect;
      }

      return cropInfo;
    }
  }]);
  return AMCropperParams;
}();

var AMCropper = /*#__PURE__*/function () {
  function AMCropper() {
    (0, _classCallCheck2["default"])(this, AMCropper);
    var self = this;
    self.cropParams = null;
    self.cropOptions = null;
    self.maxAreaWidthPx = 0;
    self.maxAreaHeightPx = 0; // Outer dimensions

    var container = {
      element: null,
      options: Object.create(null)
    };
    var paddingTop = 0;
    var paddingBottom = 0;
    var paddingLeft = 0;
    var paddingRight = 0;
    var totalWidthPx = 0;
    var totalHeightPx = 0;
    var widthPx = 0;
    var heightPx = 0;
    var wheelSupport;
    var cropParamsChanged = false;
    var cropChangingManually = false;
    var cropAreaAutoCentering = false;
    var startViewMode = false;
    var viewMode = false;
    var arealeft = 0.5; // Position of the area center inside the container

    var areatop = 0.5;
    var areawidth = 0;
    var areaheight = 0;
    var arealeftPx = 0;
    var areatopPx = 0;
    var areawidthPx = 0;
    var areaheightPx = 0;
    var areascale = 0.9;
    var desiredareascale = 0.9;
    var areamaxWidthPx = 0;
    var areamaxHeightPx = 0;
    var areaborderColor = AMConfig.cssvars.colors.front2; // the outlining for the cropBox area with resize functionality

    var areaSizerelement = null; // var areaSizerdefs = null;

    var areaSizermaskPath = null;
    var areaSizercircle = null;
    var areaSizerlineGroup = null;
    var areaSizerline1 = null;
    var areaSizerline2 = null;
    var areaSizerline3 = null;
    var areaSizerline4 = null;
    var areaSizersizersGroup = null;
    var areaSizersizerRadius = 12;
    var areaSizerresizers = {
      0: {
        0: null,
        1: null,
        2: null
      },
      1: {
        0: null,
        2: null
      },
      2: {
        0: null,
        1: null,
        2: null
      }
    };
    var lastPinchLength = 0;
    var lastPinchX = 0;
    var lastPinchY = 0;
    var touchCount = 0;
    var touchList = Object.create(null);
    var pinch1 = null;
    var pinch2 = null; // cursors:{
    //    0: { 0: 'nw-resize', 1: 'n-resize', 2: 'ne-resize' },
    //    1: { 0: 'w-resize', /*            */2: 'e-resize' },
    //    2: { 0: 'sw-resize', 1: 's-resize', 2: 'se-resize' },
    // }

    var areaSizercursors = {
      0: {
        0: 'nwse-resize',
        1: 'ns-resize',
        2: 'nesw-resize'
      },
      1: {
        0: 'ew-resize',

        /*              */
        2: 'ew-resize'
      },
      2: {
        0: 'nesw-resize',
        1: 'ns-resize',
        2: 'nwse-resize'
      }
    };
    var areaRotateelement = null;
    var areaRotatelabels = Object.create(null);
    var areaRotateyTranslate = -232;
    var areaRotategroup = null;
    var areaRotateAnimate = null;
    var areaRotateWidth = 0; // the image in the cropBox area

    var image = {
      element: null,
      originalElement: null,
      cropBoxElement: null,
      loadEvent: null,
      loadTimer: null,
      loaded: false,
      elementReplaced: false,
      widthPx: 200,
      heightPx: 150
    }; // the background image/canvas in the container

    var backImage = {
      element: null,
      loadEvent: null,
      widthPx: 0,
      heightPx: 0,
      scaleX: 1.0,
      scaleY: 1.0,
      x: 1.0,
      y: 1.0
    };

    function fixStyle(el) {
      el.style.position = 'absolute';
      el.style.overflow = 'hidden';
      el.style.border = 'none';
      el.style.cursor = 'grab'; // el.style.left = '0px'
      // el.style.top = '0px'
    }

    function childCheck(par, el) {
      if (!el.parentNode) par.appendChild(el);
    }

    function removeChildCheck(el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }

    function areaChanged() {
      self.onAreaChanged(arealeftPx, areatopPx, areawidthPx, areaheightPx);
    }

    function createSVGSizer(angle, radius, color1, cursor) {
      var c = svgEl('circle', 'fill', color1, 'r', radius);
      c.style.cursor = cursor;
      var g = svgEl('g', 'transform', 'translate(-100,-100)', '_child', c);
      areaSizersizersGroup.appendChild(g);
      return g;
    }

    function createSVGSizerGroup() {
      areaSizersizersGroup = svgEl('g');

      for (var ry = 0; ry < 3; ry++) {
        for (var rx = 0; rx < 3; rx++) {
          if (rx !== 1 || ry !== 1) {
            var angle = rx === ry ? 135 : rx === 2 - ry ? 45 : ry === 1 ? 90 : 0;
            areaSizerresizers[ry][rx] = createSVGSizer(angle, 5, AMConfig.cssvars.colors.front2, areaSizercursors[ry][rx]);
          }
        }
      }
    }

    var handleRotateTouchMove = null;
    var _handleRotateTouchEnd = null;
    var handleRotateTouchDown = null;
    var handleRotateMouseMove = null;
    var _handleRotateMouseUp = null;
    var handleRotateMouseDown = null;

    function createFreeRotateControl() {
      if (!areaRotateelement) {
        var g;
        areaRotateelement = svgEl('svg', '_child', g = svgEl('g', '_child', svgEl('circle', 'fill', AMConfig.cssvars.colors.back2, 'opacity', '0.8', 'stroke', AMConfig.cssvars.colors.front2, 'stroke-width', '2', 'cx', '0', 'cy', '0', 'r', '225'), '_child', svgEl('circle', 'fill', 'none', 'stroke', AMConfig.cssvars.colors.front2, 'stroke-width', '2', 'cx', '0', 'cy', '0', 'r', '180')));
        fixStyle(areaRotateelement);
        areaRotateelement.style.position = 'absolute';
        areaRotateelement.style.cursor = 'pointer';
        areaRotateelement.style.width = '280px';
        areaRotateelement.style.height = '48px';
        areaRotateelement.style.zIndex = '2000';
        areaRotateelement.addEventListener('mousedown', handleRotateMouseDown, false);
        areaRotateelement.addEventListener('touchstart', handleRotateTouchDown, false);

        for (var i = 0; i < 360; i += 5) {
          var indicator = svgEl('g', 'transform', "rotate(".concat(i, ")"));
          var m = i % 15;
          var t = 2;

          if (m <= 0.01) {
            var angle = 180 - (i + 180) % 360;
            var fontsize = 16;
            var fontweight = '';

            if (i % 45 < 0.01) {
              fontweight = 'bold';
              fontsize = 18;
            }

            if (i % 90 < 0.01) {
              t = 3;
              fontsize = 22;
            }

            var tx = svgEl('text', 'fill', AMConfig.cssvars.colors.front2, 'text-anchor', 'middle', 'x', angle < 0 ? -5 : 0, 'y', 199 + fontsize / 2);
            tx.style.fontWeight = fontweight;
            tx.style.fontSize = "".concat(fontsize, "px");
            tx.appendChild(document.createTextNode(angle));
            areaRotatelabels[((angle + 360) % 360).toFixed(3)] = tx;
            indicator.appendChild(tx);
          } else {
            m = 5;
            t = 1;
          }

          indicator.appendChild(svgEl('line', 'stroke', AMConfig.cssvars.colors.front2, 'stroke-width', t, 'x1', '0', 'y1', 180, 'x2', '0', 'y2', 190 - m));
          indicator.appendChild(svgEl('line', 'stroke', AMConfig.cssvars.colors.front2, 'stroke-width', t, 'x1', '0', 'y1', 215 + m, 'x2', '0', 'y2', 225));
          g.appendChild(indicator);
        }

        areaRotategroup = g;
        svgAttr(areaRotategroup, 'transform', "translate(140,-232) rotate(".concat(0, ")"));
      }
    }

    function setSVGSizerPos(el, x, y, r) {
      el.setAttributeNS(null, 'transform', "translate(".concat(x, ",").concat(y, ")"));
    }

    function updateCropParams() {
      if (cropParamsChanged) {
        self.cropParams.updateRestrictions();
        self.onChange(self);
        cropParamsChanged = false;
      }
    }

    function updateImage() {
      updateCropParams(); // var screenScale = image.widthPx / areawidthPx * self.cropParams.cropScale;

      var screenScale = areawidthPx / image.widthPx * self.cropParams.cropScale;
      var imgLeftPx = -self.cropParams.cropX * image.widthPx * screenScale;
      var imgTopPx = -self.cropParams.cropY * image.widthPx * screenScale;
      var tf = "translate3d(".concat((Math.round(arealeftPx) + imgLeftPx).toFixed(2), "px, ") + "".concat((Math.round(areatopPx) + imgTopPx).toFixed(2), "px, 0px) ") + "scale(".concat(screenScale, ",").concat(screenScale, ") ") + "rotate(".concat(self.cropParams.cropAngle, "deg)");

      if (image.element) {
        AMCore.setTransform(image.element, tf);
      }

      if (image.preview) {
        if (image.element && (image.element.nodeName !== 'IMG' || image.element.complete && image.element.src !== '')) {
          AMCore.hide(image.preview);
          image.preview = null;
        } else {
          var previewScale = areawidthPx / image.preview.clientWidth * self.cropParams.cropScale;
          imgLeftPx = -self.cropParams.cropX * image.preview.clientWidth * previewScale; // + rect.left;

          imgTopPx = -self.cropParams.cropY * image.preview.clientWidth * previewScale; // + rect.top;

          tf = "translate3d(".concat((Math.round(arealeftPx) + imgLeftPx).toFixed(2), "px, ") + "".concat((Math.round(areatopPx) + imgTopPx).toFixed(2), "px, 0px) ") + "scale(".concat(previewScale, ",").concat(previewScale, ") ") + "rotate(".concat(self.cropParams.cropAngle, "deg)");
          AMCore.setTransform(image.preview, tf);
        }
      }

      if (backImage.element && backImage.loaded) {
        imgLeftPx = (backImage.x - self.cropParams.cropX) * image.widthPx * screenScale;
        imgTopPx = (backImage.y / self.cropParams.imageAspect - self.cropParams.cropY) * image.widthPx * screenScale;
        var sx = image.widthPx / backImage.widthPx;
        var sy = image.heightPx / backImage.heightPx;
        tf = "translate3d(".concat((Math.round(arealeftPx) + imgLeftPx).toFixed(2), "px, ").concat((Math.round(areatopPx) + imgTopPx).toFixed(2), "px, 0px) scale(").concat(screenScale * backImage.scaleX * sx, ",").concat(screenScale * backImage.scaleY * sy, ") rotate(").concat(self.cropParams.cropAngle, "deg)");
        AMCore.setTransform(backImage.element, tf);
      }
    }

    function updateCropAreaParams(force) {
      if (!self.cropParams) {
        return;
      }

      if (areawidth === 0 || force) {
        arealeft = areatop = 0.5;
        var cropAreaMaxAspect = areamaxWidthPx / areamaxHeightPx;

        if (cropAreaMaxAspect < self.cropParams.cropAspect) {
          areascale = self.maxAreaWidthPx ? Math.min(self.maxAreaWidthPx / widthPx, desiredareascale) : desiredareascale;
          areawidth = areascale;
          areaheight = areascale * cropAreaMaxAspect / self.cropParams.cropAspect;
        } else {
          areascale = self.maxAreaWidthPx ? Math.min(self.maxAreaWidthPx / widthPx / self.cropParams.cropAspect * cropAreaMaxAspect, desiredareascale) : desiredareascale;
          areaheight = areascale;
          areawidth = areascale * self.cropParams.cropAspect / cropAreaMaxAspect;
        }
      }
    }

    function rotateInToView() {
      if (areaRotateyTranslate < -184) {
        areaRotateyTranslate += 6;
        areaRotateelement.style.top = "".concat(Math.round(areatopPx + areaheightPx + 0.5), "px");
        svgAttr(areaRotategroup, 'transform', "translate(".concat(areaRotateWidth / 2, ",").concat(areaRotateyTranslate, ") rotate(").concat(self.cropParams.cropAngle, ")"));
        areaRotateAnimate = requestAnimationFrame(rotateInToView);
      } else {
        areaRotateAnimate = null;
      }
    }

    function rotateOutOfView() {
      if (areaRotateyTranslate > -232) {
        areaRotateyTranslate -= 6;
        areaRotateelement.style.top = "".concat(Math.round(areatopPx + areaheightPx + 0.5), "px");
        svgAttr(areaRotategroup, 'transform', "translate(".concat(areaRotateWidth / 2, ",").concat(areaRotateyTranslate, ") rotate(").concat(self.cropParams.cropAngle, ")"));
        areaRotateAnimate = requestAnimationFrame(rotateOutOfView);
      } else {
        if (areaRotateelement) {
          removeChildCheck(areaRotateelement);
        }

        areaRotateAnimate = null;
      }
    }

    function updateCropArea() {
      if (!self.cropParams) {
        return;
      }

      updateCropParams();
      updateCropAreaParams(false);

      if (!cropChangingManually && !cropAreaAutoCentering && !viewMode) {
        areawidthPx = areawidth * widthPx;
        areaheightPx = areaheight * heightPx;
        arealeftPx = arealeft * (widthPx - areawidthPx) + paddingLeft;
        areatopPx = areatop * (heightPx - areaheightPx) + paddingTop;
        areaChanged();
      }

      var r = areawidthPx * 0.5;
      var w = totalWidthPx;
      var h = totalHeightPx;
      var w2 = areawidthPx;
      var h2 = areaheightPx;

      if (self.cropParams.cropCircle) {
        svgAttr(areaSizercircle, 'cx', Math.round(arealeftPx + r), 'cy', Math.round(areatopPx + r), 'r', Math.round(r));
        svgAttr(areaSizermaskPath, 'd', "M 0 0 h ".concat(w, " v ").concat(h, " h -").concat(w, " v -").concat(h, " M ").concat(arealeftPx, " ").concat(areatopPx + 0.5 * w2, " a ").concat(r, " ").concat(r, " 359 1 0 0 -1 l 0 1"));
      } else {
        if (areaSizersizersGroup && self.cropParams.fixedAspect <= 0) {
          var ry;
          var rx;
          var sizer;
          var newX;
          var newY;

          for (ry = 0; ry < 3; ry++) {
            for (rx = 0; rx < 3; rx++) {
              if (rx !== 1 || ry !== 1) {
                sizer = areaSizerresizers[ry][rx];
                newX = Math.round(arealeftPx + rx * areawidthPx * 0.5);
                newY = Math.round(areatopPx + ry * areaheightPx * 0.5);

                if (sizer.currentX !== newX || sizer.currentY !== newY) {
                  setSVGSizerPos(sizer, newX, newY);
                  sizer.currentX = newX;
                  sizer.currentY = newY;
                }
              }
            }
          }
        }

        var x1 = Math.round(arealeftPx);
        var y1 = Math.round(areatopPx);
        var x2 = x1 + Math.round(areawidthPx);
        var y2 = y1 + Math.round(areaheightPx);
        svgAttr(areaSizerline1, 'x1', x1, 'y1', y1, 'x2', x2, 'y2', y1);
        svgAttr(areaSizerline2, 'x1', x1, 'y1', y1, 'x2', x1, 'y2', y2);
        svgAttr(areaSizerline3, 'x1', x2, 'y1', y1, 'x2', x2, 'y2', y2);
        svgAttr(areaSizerline4, 'x1', x1, 'y1', y2, 'x2', x2, 'y2', y2); // if (!cropChangingManually && !cropAreaAutoCentering && areaSizermaskRect) {

        svgAttr(areaSizermaskPath, 'd', "M 0 0 h ".concat(w, " v ").concat(h, " h ").concat(-w, " v ").concat(-h, " M ").concat(x1, " ").concat(y1, " v ").concat(h2, " h ").concat(w2, " v ").concat(-h2, " h ").concat(-w2));
      }

      if (self.cropParams.freeRotate && !viewMode && !startViewMode) {
        if (!areaRotateelement) {
          createFreeRotateControl();
        }

        areaRotateWidth = Math.min(280, areawidthPx);
        areaRotateelement.style.width = "".concat(areaRotateWidth, "px");
        areaRotateelement.style.left = "".concat(Math.round(arealeftPx + areawidthPx * 0.5 - areaRotateWidth / 2), "px");
        areaRotateelement.style.top = "".concat(Math.round(areatopPx + areaheightPx + 0.5), "px");
        svgAttr(areaRotategroup, 'transform', "translate(".concat(areaRotateWidth / 2, ",").concat(areaRotateyTranslate, ") ") + "rotate(".concat(self.cropParams.cropAngle, ")"));

        if (areaRotateyTranslate < -180) {
          if (!areaRotateAnimate) {
            areaRotateAnimate = requestAnimationFrame(rotateInToView);
          }
        }

        for (var lbl in areaRotatelabels) {
          if (Math.abs(lbl % 45 - 0) < 0.01) {
            svgAttr(areaRotatelabels[lbl], 'fill', lbl === self.cropParams.cropAngle.toFixed(3) ? AMConfig.cssvars.colors.front1 : AMConfig.cssvars.colors.front2);
          }
        }

        childCheck(container.element, areaRotateelement);
      } else {
        if (areaRotateyTranslate > -232) {
          if (!areaRotateAnimate) {
            areaRotateAnimate = requestAnimationFrame(rotateOutOfView);
          }
        }
      }

      updateImage();
    }

    function positionAreaAfterManual() {
      if (!cropAreaAutoCentering) {
        return;
      }

      var desiredWidthPx = areawidth * widthPx;
      var desiredHeightPx = areaheight * heightPx;
      var desiredLeftPx = arealeft * (widthPx - areawidthPx) + paddingLeft;
      var desiredTopPx = areatop * (heightPx - areaheightPx) + paddingTop;
      var updated = false;

      if (Math.abs(areawidthPx - desiredWidthPx) >= 0.1 || Math.abs(areaheightPx - desiredHeightPx) >= 0.1 || Math.abs(arealeftPx - desiredLeftPx) >= 0.1 || Math.abs(areatopPx - desiredTopPx) >= 0.1) {
        desiredLeftPx += areawidthPx / 2;
        desiredTopPx += areaheightPx / 2;
        arealeftPx += areawidthPx / 2;
        areatopPx += areaheightPx / 2;
        areawidthPx = (2 * areawidthPx + desiredWidthPx) / 3;
        areaheightPx = (2 * areaheightPx + desiredHeightPx) / 3;
        arealeftPx = (arealeftPx + desiredLeftPx) / 2;
        areatopPx = (areatopPx + desiredTopPx) / 2;
        arealeftPx -= areawidthPx / 2;
        areatopPx -= areaheightPx / 2;
        areaChanged();
        updated = true;
      }

      if (updated) {
        if (cropChangingManually) {
          cropAreaAutoCentering = false;
        } else {
          window.requestAnimationFrame(positionAreaAfterManual);
        }
      } else {
        // areaSizermaskBackRect.style.visibility = 'visible';
        cropAreaAutoCentering = false;

        if (startViewMode) {
          startViewMode = false;
          viewMode = true;
        }
      }

      updateCropArea();
    }

    function triggerAutoCenter(windowSizeChanged) {
      cropChangingManually = false;

      if (!cropAreaAutoCentering) {
        if ((self.cropParams && viewMode || !image.element) && !windowSizeChanged) {
          updateCropArea();
        } else {
          // areaSizermaskBackRect.style.visibility = 'hidden';
          cropAreaAutoCentering = true;
          updateCropAreaParams(true);
          window.requestAnimationFrame(positionAreaAfterManual);
        }
      }
    }

    function updateSize(windowSizeChanged) {
      var maxScale = 0.9;
      totalWidthPx = container.element.clientWidth;
      totalHeightPx = container.element.clientHeight;
      widthPx = totalWidthPx - paddingLeft - paddingRight;
      heightPx = totalHeightPx - paddingBottom - paddingTop;
      areamaxWidthPx = maxScale * widthPx;
      areamaxHeightPx = maxScale * heightPx; // var r = areawidthPx / 2;

      svgAttr(areaSizerelement, 'width', totalWidthPx, 'height', totalHeightPx);

      if (container.options.fixedControls) {
        var rect;

        if (image.cropBoxElement) {
          rect = image.cropBoxElement.getBoundingClientRect();
        } else {
          rect = container.element.getBoundingClientRect();
        }

        areaSizerelement.style.left = ~~window.scrollX + rect.left + 'px';
        areaSizerelement.style.top = ~~window.scrollY + rect.top + 'px';
      }

      if (image.cropBoxElement) {
        image.cropBoxElement.style.width = totalWidthPx + 'px';
        image.cropBoxElement.style.height = totalHeightPx + 'px';
      }

      updateCropAreaParams(true);
      triggerAutoCenter(windowSizeChanged);
      updateCropArea();
    }

    var replaceOnComplete = null;

    function imageLoaded() {
      self.cropParams.loadedImage = true;

      if (container.options.convertSourceElement && !image.elementReplaced) {
        if (image.element) {
          replaceOnComplete();
        }
      }

      if (image.element) {
        if (image.element.nodeName !== 'IMG') {
          if (image.element.nodeName === 'CANVAS') {
            image.widthPx = image.element.width;
            image.heightPx = image.element.height;
          } else {
            image.widthPx = image.element.clientWidth;
            image.heightPx = image.element.clientHeight;
          }
        }

        self.onLoaded(self, true);
      } else {
        if (image.preview) {
          image.widthPx = image.preview.clientWidth;
          image.heightPx = image.preview.clientHeight;
        }
      }

      if (isNaN(image.widthPx)) image.widthPx = 200;
      if (isNaN(image.heightPx)) image.heightPx = 150;

      if (!image.heightPx) {
        image.heightPx = 1;
      }

      if (!image.widthPx) {
        image.widthPx = 1;
      }

      self.cropParams.imageAspect = image.widthPx / image.heightPx;
      cropParamsChanged = true;
      updateCropParams();
      updateSize(true);

      if (image.element) {
        image.element.style.visibility = 'visible';
      }
    }

    function replaceImageElement() {
      if (!image.elementReplaced) {
        image.elementReplaced = true;
        image.originalElement = image.element;
        removeChildCheck(image.element);
        image.element = container.options.convertSourceElement(image.originalElement);
        AMCore.setTransformOrigin(image.element, '0 0');
        self.insertImageElement();
        imageLoaded();
      }
    }

    replaceOnComplete = function (_replaceOnComplete) {
      function replaceOnComplete() {
        return _replaceOnComplete.apply(this, arguments);
      }

      replaceOnComplete.toString = function () {
        return _replaceOnComplete.toString();
      };

      return replaceOnComplete;
    }(function () {
      if (image.element && image.element.complete === false) {
        setTimeout(replaceOnComplete, 100);
      } else {
        replaceImageElement();
      }
    });

    var angleToSkip = -1;
    var startCropScale = -1;

    function rotateCrop(angleDelta) {
      if (!self.cropParams.loadedImage) {
        return;
      }

      var cropAngle = self.cropParams.cropAngle + angleDelta;
      var delta45 = (cropAngle + 360 + 22.5) % 45 - 22.5;

      if (angleToSkip === -1 || Math.abs((cropAngle + 20) % 360 - angleToSkip - 20) > 14.5) {
        angleToSkip = -1;

        if (Math.abs(delta45) < 4.5) {
          cropAngle -= delta45;
          cropAngle = cropAngle.toFixed(3);
          angleDelta = cropAngle - self.cropParams.cropAngle;
        }
      }

      if (startCropScale !== -1) {
        self.cropParams.cropScale = startCropScale;
      }

      self.cropParams.cropAngle = Math.abs((cropAngle + 360) % 360);
      cropParamsChanged = true; // Correct top left for rotation arround center of crop

      var angleRAD = angleDelta / 180 * Math.PI;
      var sin = Math.sin(angleRAD);
      var cos = Math.cos(angleRAD);
      var topLeftX = -self.cropParams.cropX - 0.5 / self.cropParams.cropScale;
      var topLeftY = -self.cropParams.cropY - 0.5 / self.cropParams.cropScale / self.cropParams.cropAspect;
      self.cropParams.cropX += topLeftX - (topLeftX * cos + topLeftY * -sin);
      self.cropParams.cropY += topLeftY - (topLeftY * cos + topLeftX * sin);
      updateCropArea();
      return angleDelta;
    }

    function moveCrop(x, y) {
      if (viewMode || !self.cropParams.loadedImage) {
        // arealeftPx += x;
        // areatopPx += y;
        // updateSize(false);
        // areaChanged();
        return;
      }

      var screenScale = areawidthPx / image.widthPx * self.cropParams.cropScale;
      self.cropParams.cropX -= x / screenScale / image.widthPx;
      self.cropParams.cropY -= y / screenScale / image.widthPx;
      cropParamsChanged = true;
    }

    function zoom(x, y, newCropScale, divideAreaWidth) {
      if (!self.cropParams.loadedImage) {
        return;
      }

      var rect = container.element.getBoundingClientRect();
      x = x === -1 ? 0.5 : x - (rect.left + arealeftPx); // / areawidthPx;

      y = y === -1 ? 0.5 : y - (rect.top + areatopPx); // / areaheightPx;

      if (viewMode) {
        // arealeftPx -= x * delta;
        // areatopPx -= y * delta;
        //
        // areawidthPx *= 1.0 + delta;
        // areaheightPx *= 1.0 + delta;
        // updateCropAreaParams(true);
        // updateSize(false);
        // areaChanged();
        return;
      }

      if (divideAreaWidth) {
        x /= areawidthPx;
        y /= areaheightPx;
      }

      var cs = self.cropParams.cropScale;
      self.cropParams.cropScale = newCropScale;
      self.cropParams.cropScale = Math.min(self.cropParams.cropScale, self.cropParams.maxScale);
      self.cropParams.cropScale = Math.max(self.cropParams.cropScale, self.cropParams.minAspectScale);
      var delta = self.cropParams.cropScale / cs - 1.0;
      self.cropParams.cropX += x * delta / self.cropParams.cropScale;
      self.cropParams.cropY += y * delta / self.cropParams.cropScale * ( //* (image.widthPx / image.heightPx)
      areaheightPx / areawidthPx);
      cropParamsChanged = true;
    }

    self.setZoom = function (x, y, newCropScale) {
      zoom(x, y, newCropScale);
      updateImage();
    };

    function zoomCrop(x, y, delta) {
      var newValue = self.cropParams.cropScale * (1.0 + delta);
      zoom(x, y, newValue, true);
    }

    var Sizer = /*#__PURE__*/function () {
      function Sizer(x, y) {
        (0, _classCallCheck2["default"])(this, Sizer);
        this.sizerMoving = true;
        this.sizerMoveX = x;
        this.sizerMoveY = y;
      }

      (0, _createClass2["default"])(Sizer, [{
        key: "move",
        value: function move(deltaX, deltaY) {
          if (!self.cropParams.loadedImage) {
            return;
          }

          deltaX *= -(this.sizerMoveX - 1);
          deltaY *= -(this.sizerMoveY - 1);
          var oldWidthPx = areawidthPx; // var oldHeightPx = areaheightPx;

          deltaX = Math.min(deltaX, areawidthPx - 25);
          deltaY = Math.min(deltaY, areaheightPx - 25);
          areawidthPx -= deltaX;
          areaheightPx -= deltaY;
          if (this.sizerMoveX === 0) arealeftPx += deltaX;
          if (this.sizerMoveY === 0) areatopPx += deltaY;
          self.cropParams.cropScale *= oldWidthPx / areawidthPx;
          if (this.sizerMoveX === 0) self.cropParams.cropX += deltaX / (self.cropParams.cropScale * areawidthPx);
          if (this.sizerMoveY === 0) self.cropParams.cropY += deltaY / (self.cropParams.cropScale * areawidthPx);
          self.cropParams.cropAspect = areawidthPx / areaheightPx;
          areaheightPx = areawidthPx / self.cropParams.cropAspect;
          cropParamsChanged = true;
          updateCropArea();
          areaChanged();
        }
      }, {
        key: "finish",
        value: function finish() {
          this.sizerMoveX = -1;
          this.sizerMoveY = -1;

          if (this.sizerMoving) {
            this.sizerMoving = false;
            triggerAutoCenter(false);
          }
        }
      }]);
      return Sizer;
    }();

    function checkSizer(screenX, screenY, factor) {
      if (self.cropParams.fixedAspect > 0 || viewMode || startViewMode) {
        return false;
      }

      var x;
      var y;
      var dx;
      var dy;
      var rect = container.element.getBoundingClientRect();
      var deltaTreshold = areaSizersizerRadius * areaSizersizerRadius * factor;

      for (var ry = 0; ry < 3; ry++) {
        for (var rx = 0; rx < 3; rx++) {
          if (rx !== 1 || ry !== 1) {
            x = rect.left + arealeftPx + rx * areawidthPx * 0.5;
            y = rect.top + areatopPx + ry * areaheightPx * 0.5;
            dx = screenX - x;
            dy = screenY - y;

            if (dx * dx + dy * dy < deltaTreshold) {
              // areaSizermaskBackRect.style.visibility = 'hidden';
              // areaSizermaskBackRect.style.opacity = '0.0';
              cropChangingManually = true;
              return new Sizer(rx, ry);
            }
          }
        }
      }

      return null;
    }

    var mouseSizer = null;
    var lastMouseX = 0;
    var lastMouseY = 0;
    var mouseMoved = false;

    function handleMove(e) {
      e.preventDefault();
      var dx = e.clientX - lastMouseX;
      var dy = e.clientY - lastMouseY;

      if (mouseSizer) {
        mouseSizer.move(dx, dy);
      } else {
        moveCrop(dx, dy);
        updateImage();
      }

      if (dx * dx + dy * dy > 5) {
        mouseMoved = true;
      }

      lastMouseX = e.clientX;
      lastMouseY = e.clientY;
    }

    function handleUp(e) {
      e.preventDefault();
      window.removeEventListener('mousemove', handleMove, false);
      window.removeEventListener('mouseup', handleUp, false);

      if (mouseSizer) {
        mouseSizer.finish();
      } else {
        if (!mouseMoved && container.options.allowViewModeSwitch) {
          var rect = container.element.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          var clickY = e.clientY - rect.top;
          self.setViewMode(!(arealeftPx < clickX && clickX < arealeftPx + areawidthPx && areatopPx < clickY && clickY < areatopPx + areaheightPx));

          if (!viewMode && !startViewMode) {
            container.element.focus();
          }

          self.updateCropVisuals();
        }
      }
    }

    function handleMouseDown(e) {
      // container.element.focus();
      // e.preventDefault();
      lastMouseX = e.clientX;
      lastMouseY = e.clientY;
      mouseMoved = false;
      mouseSizer = checkSizer(lastMouseX, lastMouseY, 1);
      window.addEventListener('mousemove', handleMove, false);
      window.addEventListener('mouseup', handleUp, false);
    }

    var TouchRecord = /*#__PURE__*/function () {
      function TouchRecord(id) {
        (0, _classCallCheck2["default"])(this, TouchRecord);
        this.id = id;
        this.inUse = true;
        this.lastTouchX = 0;
        this.lastTouchY = 0;
        this.sizer = null;
      }

      (0, _createClass2["default"])(TouchRecord, [{
        key: "resetInUse",
        value: function resetInUse() {
          this.inUse = false;
        }
      }, {
        key: "handleStart",
        value: function handleStart(t) {
          this.lastTouchX = t.clientX;
          this.lastTouchY = t.clientY;
          this.sizer = checkSizer(this.lastTouchX, this.lastTouchY, 3);

          if (!this.sizer) {
            if (!pinch1) pinch1 = this;else if (!pinch2) pinch2 = this;

            if (pinch1 && pinch2) {
              var dx = pinch1.lastTouchX - pinch2.lastTouchX;
              var dy = pinch1.lastTouchY - pinch2.lastTouchY;
              lastPinchX = (pinch1.lastTouchX + pinch2.lastTouchX) / 2;
              lastPinchY = (pinch1.lastTouchY + pinch2.lastTouchY) / 2;
              lastPinchLength = Math.sqrt(dx * dx + dy * dy);
            }
          }
        }
      }, {
        key: "handleMove",
        value: function handleMove(t) {
          var newX = t.clientX;
          var newY = t.clientY;

          if (this.sizer) {
            this.sizer.move(newX - this.lastTouchX, newY - this.lastTouchY);
          } else {
            if (this === pinch1 && !pinch2) {
              moveCrop(newX - this.lastTouchX, newY - this.lastTouchY);
            } else {
              if (this === pinch2 && pinch1) {
                var dx = pinch1.lastTouchX - newX;
                var dy = pinch1.lastTouchY - newY;
                var newPinchLength = Math.sqrt(dx * dx + dy * dy);
                var newPinchX = (newX + pinch1.lastTouchX) / 2;
                var newPinchY = (newY + pinch1.lastTouchY) / 2;
                moveCrop(newPinchX - lastPinchX, newPinchY - lastPinchY);
                lastPinchX = newPinchX;
                lastPinchY = newPinchY;
                zoomCrop(newPinchX, newPinchY, newPinchLength / lastPinchLength - 1.0);
                lastPinchLength = newPinchLength;
              }
            }
          }

          updateImage();
          this.lastTouchX = newX;
          this.lastTouchY = newY;
        }
      }, {
        key: "handleEnd",
        value: function handleEnd(t) {
          if (this.sizer) {
            this.sizer.finish();
          }
        }
      }]);
      return TouchRecord;
    }();

    function handleTouches(e) {
      e.preventDefault();
      var tr;

      for (tr in touchList) {
        touchList[tr].resetInUse();
      }

      var touchRec;
      var id;

      for (var i = 0; i < e.touches.length; i++) {
        id = e.touches[i].identifier;

        if (Object.hasOwnProperty.call(touchList, id)) {
          touchRec = touchList[id];
          touchRec.handleMove(e.touches[i]);
        } else {
          touchRec = new TouchRecord(id);
          touchList[id] = touchRec;
          touchRec.handleStart(e.touches[i]);
        }

        touchRec.inUse = true;
      }

      for (id in touchList) {
        tr = touchList[id];

        if (!tr.inUse) {
          tr.handleEnd();
          delete touchList[id];
          if (pinch1 && pinch1.id === tr.id) pinch1 = null;
          if (pinch2 && pinch2.id === tr.id) pinch2 = null;
        }
      }
    }

    function handleTouchMove(e) {
      e.preventDefault();
      handleTouches(e);
    }

    function handleTouchEnd(e) {
      e.preventDefault();
      handleTouches(e);

      if (--touchCount === 0 || e.touches.length === 0) {
        window.removeEventListener('touchmove', handleTouchMove, false);
        window.removeEventListener('touchend', handleTouchEnd, false);
        window.removeEventListener('touchcancel', handleTouchEnd, false);
        touchCount = 0;
      }
    }

    function handleTouchDown(e) {
      e.preventDefault();

      if (++touchCount === 1) {
        window.addEventListener('touchmove', handleTouchMove, false);
        window.addEventListener('touchend', handleTouchEnd, false);
        window.addEventListener('touchcancel', handleTouchEnd, false);
      }

      handleTouches(e);
    }

    function handleWheel(e) {
      var delta = 0;
      e.preventDefault();

      if (e.deltaY) {
        delta = e.deltaY > 0 ? 1 : -1;
      } else if (e.wheelDelta) {
        delta = -e.wheelDelta / 120;
      } else if (e.detail) {
        delta = e.detail > 0 ? 1 : -1;
      }

      var x = -1;
      var y = -1;
      if (e.clientX) x = e.clientX;
      if (e.clientY) y = e.clientY;
      zoomCrop(x, y, delta * -0.05);
      cropParamsChanged = true;
      updateImage();
    }

    function getAngle(pageX, pageY) {
      var rect = areaRotateelement.getBoundingClientRect();
      return Math.atan2(pageX - (rect.left + rect.right) * 0.5, pageY - (rect.top - 180)) / Math.PI * 180;
    }

    var rotateDownX;

    handleRotateMouseMove = function handleRotateMouseMove(e) {
      e.preventDefault();
      e.stopPropagation();
      var angle = getAngle(e.clientX, e.clientY);
      var angleDelta = rotateDownX - angle;
      var newDelta = rotateCrop(angleDelta);
      rotateDownX -= newDelta;
    };

    _handleRotateMouseUp = function handleRotateMouseUp(e) {
      e.preventDefault();
      e.stopPropagation();
      startCropScale = -1;
      window.removeEventListener('mousemove', handleRotateMouseMove, false);
      window.removeEventListener('mouseup', _handleRotateMouseUp, false);
    };

    handleRotateMouseDown = function handleRotateMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
      angleToSkip = self.cropParams.cropAngle;
      rotateDownX = getAngle(e.clientX, e.clientY);
      startCropScale = self.cropParams.cropScale;
      window.addEventListener('mousemove', handleRotateMouseMove, false);
      window.addEventListener('mouseup', _handleRotateMouseUp, false);
    };

    var rotateTouchID = 0;

    handleRotateTouchMove = function handleRotateTouchMove(e) {
      e.preventDefault();
      e.stopPropagation();
      var rotateTouchIX = e.touches.length - 1;

      for (rotateTouchIX = 0; rotateTouchIX < e.touches.length; rotateTouchIX++) {
        if (e.touches[rotateTouchIX].identifier === rotateTouchID) {
          break;
        }
      }

      var angle = getAngle(e.touches[rotateTouchIX].clientX, e.touches[rotateTouchIX].clientY);
      var angleDelta = rotateDownX - angle;
      rotateDownX -= rotateCrop(angleDelta);
    };

    _handleRotateTouchEnd = function handleRotateTouchEnd(e) {
      e.preventDefault();
      e.stopPropagation();
      startCropScale = -1;
      window.removeEventListener('touchmove', handleRotateTouchMove, false);
      window.removeEventListener('touchend', _handleRotateTouchEnd, false);
      window.removeEventListener('touchcancel', _handleRotateTouchEnd, false);
    };

    handleRotateTouchDown = function handleRotateTouchDown(e) {
      e.preventDefault();
      e.stopPropagation();
      var rotateTouchIX = e.touches.length - 1;
      rotateTouchID = e.touches[rotateTouchIX].identifier;
      startCropScale = self.cropParams.cropScale;
      angleToSkip = self.cropParams.cropAngle;
      rotateDownX = getAngle(e.touches[rotateTouchIX].clientX, e.touches[rotateTouchIX].clientY);
      window.addEventListener('touchmove', handleRotateTouchMove, false);
      window.addEventListener('touchend', _handleRotateTouchEnd, false);
      window.addEventListener('touchcancel', _handleRotateTouchEnd, false);
    };

    function imageLoader(stateRecord, src) {
      stateRecord.loaded = false;
      stateRecord.errorOccured = false;
      stateRecord.waitCount = 0;
      stateRecord.element.style.opacity = 0;
      AMCore.setTransition(stateRecord.element, 'opacity 500ms'); // stateRecord.element.style.visibility = 'hidden';
      // stateRecord.element.style.backgroundImage = AMCropper.checkerBoardBackground;
      // stateRecord.element.style.width = '100%';
      // stateRecord.element.style.height = '100%';

      AMCore.setTransformOrigin(stateRecord.element, '0 0');
      fixStyle(stateRecord.element, true);
      var loadTimer;
      var element = stateRecord.element;

      function finishedLoading() {
        if (loadTimer) {
          clearInterval(loadTimer);
          loadTimer = null;
        }

        if (!stateRecord.loaded) {
          stateRecord.loaded = true; // stateRecord.element.style.width = '';
          // stateRecord.element.style.height = '';

          if (stateRecord.element) {
            stateRecord.element.style.opacity = stateRecord.targetOpacity || 1.0;
            stateRecord.widthPx = stateRecord.element.naturalWidth;
            stateRecord.heightPx = stateRecord.element.naturalHeight;

            if (!stateRecord.widthPx) {
              stateRecord.widthPx = stateRecord.element.clientWidth;
              stateRecord.heightPx = stateRecord.element.clientHeight;
            }

            if (stateRecord.loadEvent) {
              stateRecord.loadEvent();
            }
          }
        }
      }

      stateRecord.element.onload = function () {
        finishedLoading();
      };

      stateRecord.element.onerror = function (e) {
        stateRecord.errorOccured = true;
        console.log('Image load error: ', e); // IE SUCKS finishedLoading();
      };

      loadTimer = setInterval(function () {
        if (++stateRecord.waitCount > (stateRecord.errorOccured ? 200 : 3000)) {
          stateRecord.element.src = AMCropper.checkerBoardImage;
          finishedLoading();
        } else {
          if (element !== stateRecord.element) {
            clearInterval(loadTimer);
            loadTimer = null;
          } else if (stateRecord.element.naturalHeight) {
            finishedLoading();
          }
        }
      }, 20);
      stateRecord.element.src = src;
    }

    self.updateContainerOptions = function (options) {
      if (options) {
        for (var opt in options) {
          container.options[opt] = options[opt];
        }
      }

      var computed = window.getComputedStyle(container.element);
      paddingTop = ~~parseInt(computed.paddingTop) + ~~container.options.topMargin;
      paddingBottom = ~~parseInt(computed.paddingBottom) + ~~container.options.bottomMargin;
      paddingLeft = ~~parseInt(computed.paddingLeft);
      paddingRight = ~~parseInt(computed.paddingRight);
    };

    function handelResize() {
      updateSize(true);
    }

    self.initialize = function (containerElement, options) {
      container.element = containerElement;
      container.element.dataCropper = self.updateContainerOptions(options);

      if (container.options.allowViewModeSwitch) {
        container.element.onblur = function (e) {
          // Fix for Edge which seems to blur to nested elements
          if (document.activeElement === areaSizerelement) {
            container.element.focus();
            return false;
          } else {
            // console.log('blurcropper: ', e);
            // console.log(document.activeElement);
            self.setViewMode(true);
            self.updateCropVisuals();
            self.onBlur();
          }
        };
      }

      areaSizerelement = svgEl('svg', '_child', areaSizermaskPath = svgEl('path', 'fill', AMConfig.cssvars.colors.back1, 'opacity', 0.7));
      AMCore.setTransition(areaSizermaskPath, 'opacity 300ms');
      fixStyle(areaSizerelement, true);

      if (container.options.fixedControls) {
        document.body.appendChild(areaSizerelement);
        var rect = container.element.getBoundingClientRect();
        areaSizerelement.style.left = ~~window.scrollX + rect.left + 'px';
        areaSizerelement.style.top = ~~window.scrollY + rect.top + 'px';
      } else {
        container.element.appendChild(areaSizerelement);
      }

      window.addEventListener('resize', handelResize); // container.element.addEventListener('mousedown', handleMouseDown, false);
      // container.element.addEventListener('touchstart', handleTouchDown, false);

      container.element.onmousedown = handleMouseDown;
      container.element.ontouchdown = handleTouchDown;

      if (!options.disableZoomScroll) {
        // wheel detect: https://developer.mozilla.org/en-US/docs/Web/Events/wheel
        wheelSupport = 'onwheel' in container.element ? 'wheel' // Modern browsers support "wheel"
        : document.onmousewheel !== undefined ? 'mousewheel' // Webkit and IE support at least "mousewheel"
        : 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox

        container.element.addEventListener(wheelSupport, handleWheel, false);
      }

      updateSize(true);
    };

    self.destroy = function () {
      removeChildCheck(areaSizerelement);
      self.removeImageElement();
      removeChildCheck(backImage.element);
      container.element.removeEventListener('mousedown', handleMouseDown);
      container.element.removeEventListener('touchstart', handleTouchDown);

      if (wheelSupport) {
        container.element.removeEventListener(wheelSupport, handleWheel);
      }

      window.removeEventListener('resize', handelResize);

      if (areaRotateelement) {
        areaRotateelement.removeEventListener('mousedown', handleRotateMouseDown, false);
        areaRotateelement.removeEventListener('touchstart', handleRotateTouchDown, false);
        removeChildCheck(areaRotateelement);
      }
    };

    var insertBeforeAreaSizer = function insertBeforeAreaSizer(element) {
      if (container.options.fixedControls) {
        childCheck(container.element, element);
      } else {
        container.element.insertBefore(element, areaSizerelement);
      }
    };

    self.updateCropVisuals = function () {
      if (!self.cropParams) {
        return;
      }

      removeChildCheck(areaSizersizersGroup);

      if (self.cropParams.cropCircle) {
        desiredareascale = self.cropOptions.cropAreaScale || 0.95;
        removeChildCheck(areaSizerlineGroup);
        self.cropParams.fixedAspect = 1.0;

        if (!areaSizercircle) {
          areaSizercircle = svgEl('circle', 'fill', 'none', 'stroke', areaborderColor, 'stroke-width', 2);
        }

        childCheck(areaSizerelement, areaSizercircle);
        AMCore.setTransition(areaSizercircle, 'visibility 500ms');
        areaSizercircle.style.visibility = viewMode || startViewMode ? 'hidden' : 'visible';
      } else {
        desiredareascale = self.cropOptions.cropAreaScale || 0.9;
        removeChildCheck(areaSizercircle);

        if (!areaSizerlineGroup) {
          areaSizerlineGroup = svgEl('g', '_child', areaSizerline1 = svgEl('line', 'stroke', areaborderColor, 'stroke-width', 5), '_child', areaSizerline2 = svgEl('line', 'stroke', areaborderColor, 'stroke-width', 5), '_child', areaSizerline3 = svgEl('line', 'stroke', areaborderColor, 'stroke-width', 5), '_child', areaSizerline4 = svgEl('line', 'stroke', areaborderColor, 'stroke-width', 5));
        }

        childCheck(areaSizerelement, areaSizerlineGroup);
        AMCore.setTransition(areaSizerlineGroup, 'opacity 500ms');
        areaSizerlineGroup.style.opacity = viewMode || startViewMode ? 0.0 : 1.0;
      }

      if (self.cropParams.fixedAspect <= 0) {
        if (!areaSizersizersGroup) {
          createSVGSizerGroup();
        }

        desiredareascale = self.cropOptions.cropAreaScale || 0.7;
        areaSizerelement.appendChild(areaSizersizersGroup);
        areaSizersizersGroup.style.visibility = viewMode || startViewMode ? 'hidden' : 'visible';
      } else {
        self.cropParams.cropAspect = self.cropParams.fixedAspect;
      } // if (options.maxAreaScale) {


      if (viewMode || startViewMode) {
        desiredareascale = self.cropOptions.cropAreaScale || 0.9;
      }

      svgAttr(areaSizermaskPath, 'opacity', viewMode || startViewMode ? 1.0 : 0.7);
      updateSize(false);
    };

    self.setViewMode = function (vm) {
      if (vm) {
        if (!viewMode && !startViewMode) {
          self.onFinished(self, true);
        }

        startViewMode = true;
        viewMode = false;
      } else {
        startViewMode = false;
        viewMode = false;
      }

      updateSize(true);
      triggerAutoCenter(true);
    };

    self.removeImageElement = function () {
      if (image.cropBoxElement) {
        removeChildCheck(image.cropBoxElement);
        image.cropBoxElement = null;
      }

      removeChildCheck(image.element);
      image.element = null;
    };

    self.insertImageElement = function () {
      fixStyle(image.element, true);

      if (self.cropOptions.boxSource) {
        if (!image.cropBoxElement) {
          image.cropBoxElement = document.createElement('div');
          fixStyle(image.cropBoxElement);
          image.cropBoxElement.style.position = 'absolute';
          image.cropBoxElement.style.width = '100%';
          image.cropBoxElement.style.height = '100%';
        }

        childCheck(image.cropBoxElement, image.element);
        insertBeforeAreaSizer(image.cropBoxElement);
      } else {
        insertBeforeAreaSizer(image.element);
      }
    };

    var loadDelayTimout = null;

    self.load = function (content, cropParams, cropOptions) {
      if (cropParams instanceof AMCropper.CropParams) {
        self.cropParams = cropParams;
      } else {
        self.cropParams = new AMCropper.CropParams(cropParams);
      }

      self.cropOptions = cropOptions || {};

      if (self.cropParams.fixedAspect > 0) {
        self.cropParams.cropAspect = self.cropParams.fixedAspect;
      } else {
        if (!self.cropParams.hasOwnProperty('cropAspect') || self.cropParams.cropAspect <= 0) {
          self.cropParams.autoAspect = true;
        }
      }

      if (loadDelayTimout) {
        clearTimeout(loadDelayTimout);
        loadDelayTimout = null;
      }

      self.removeImageElement();
      image.originalElement = null;
      removeChildCheck(backImage.element);
      backImage.element = null;
      backImage.loaded = false;
      image.loaded = false;
      self.updateCropVisuals();
      image.elementReplaced = false;
      image.widthPx = 0;
      image.heightPx = 0;
      cropParamsChanged = true;
      cropChangingManually = false;
      cropAreaAutoCentering = false;
      areawidth = 0;

      if (self.cropOptions.previewElement) {
        image.preview = self.cropOptions.previewElement;
        imageLoaded();
      } else {
        image.preview = null;
        updateSize(false);
      }

      if (self.cropParams.backContent) {
        backImage.element = new window.Image();
        backImage.element.style.pointerEvents = 'none';
        backImage.scaleX = self.cropParams.backScale || 1.0;
        backImage.scaleY = self.cropParams.backScale || 1.0;
        backImage.x = self.cropParams.backX || 0.0;
        backImage.y = self.cropParams.backY || 0.0;
        backImage.loadEvent = updateImage;
        backImage.targetOpacity = self.cropParams.backOpactity || 1.0;
        imageLoader(backImage, self.cropParams.backContent);
        insertBeforeAreaSizer(backImage.element);
      }

      if (typeof content === 'string' || content instanceof String) {
        image.element = new window.Image();
        image.originalElement = image.element;
        self.insertImageElement();
        image.element.crossOrigin = 'anonymous';
        image.loadEvent = imageLoaded;

        if (self.cropOptions.loadDelay) {
          loadDelayTimout = setTimeout(function () {
            loadDelayTimout = null;
            imageLoader(image, content);
          }, self.cropOptions.loadDelay);
        } else {
          imageLoader(image, content);
        }
      } else {
        removeChildCheck(content);
        image.element = content;
        image.originalElement = image.element;
        AMCore.setTransformOrigin(image.element, '0 0');
        self.insertImageElement();
        image.loaded = true;
        imageLoaded();
      }
    };

    self.updateCropView = function () {
      cropParamsChanged = true;
      updateCropArea();
    };

    self.getImageSize = function () {
      return {
        width: image.widthPx,
        height: image.heightPx
      };
    };

    self.calcCropInfo = function () {
      var maxDesiredRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MAX_DESIRED_RATIO;
      var minDesiredRadio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MIN_DESIRED_RATIO;
      var info = self.cropParams.calcCropInfo(maxDesiredRatio, minDesiredRadio);

      if (image.widthPx && info.rect) {
        info.imageSize = {
          width: image.widthPx,
          height: image.heightPx
        };
      }

      return info;
    };

    self.getContainer = function () {
      return container;
    };

    self.updateImageSize = function () {
      imageLoaded();
    };

    self.updateCropScale = function (x, y, newValue) {
      zoomCrop(x, y, newValue / self.cropParams.cropScale - 1.0);
      cropParamsChanged = true;
      updateImage();
    };

    self.rotate90 = function (clockwise) {
      var newAspect = 1.0 / self.cropParams.cropAspect;
      var newScale = self.cropParams.cropScale / newAspect;
      var scaleDelta = 1 / self.cropParams.cropScale - 1 / newScale;
      self.cropParams.cropX += 0.5 * scaleDelta; // / self.cropParams.cropScale;

      self.cropParams.cropY -= 0.5 * scaleDelta; // / self.cropParams.cropScale;

      self.cropParams.cropScale = newScale; // / self.cropParams.cropAspect;

      self.cropParams.cropAspect = newAspect;
      rotateCrop(clockwise ? 90 : -90);

      if (image.loaded) {
        updateSize(false);
      }
    };

    self.getCanvas = function (options) {
      options = options || {};
      options.cropParams = self.cropParams;

      if (image.element && image.loaded) {
        if (image.originalElement && options.skipEffects) {
          return AMCropper.getResizedCanvas(image.originalElement, options);
        } else {
          return AMCropper.getResizedCanvas(image.element, options);
        }
      } else {
        return null;
      }
    };

    self.getDataURL = function (type, quality, options) {
      options = options || {};
      options.cropParams = self.cropParams;
      return AMCropper.getResizedImageUrl(image.element, type, quality, options);
    }; // function to replace for updates


    self.onChange = AMCore.nop;
    self.onLoaded = AMCore.nop;
    self.onFinished = AMCore.nop;
    self.onAreaChanged = AMCore.nop;
    self.onBlur = AMCore.nop;
  }

  (0, _createClass2["default"])(AMCropper, null, [{
    key: "getResizedCanvas",
    value: function getResizedCanvas(image, options) {
      var scaledWidth = 0;
      var scaledHeight = 0;
      var optionCrop = (options || {}).cropParams;
      var cropParams = new AMCropperParams(optionCrop);
      var widthPx = 0;
      var heightPx = 0; // TODO: put in function

      if (image.nodeName === 'IMG') {
        widthPx = image.naturalWidth;
        heightPx = image.naturalHeight;
      } else if (image.nodeName === 'CANVAS') {
        widthPx = image.width;
        heightPx = image.height;
      } else {
        widthPx = image.clientWidth;
        heightPx = image.clientHeight;
      }

      if (!optionCrop) {
        cropParams.cropAspect = widthPx / heightPx;
      }

      if (options && options.width) {
        scaledWidth = options.width;

        if (options.height) {
          scaledHeight = options.height;
          cropParams.fixedAspect = scaledWidth / scaledHeight;
          cropParams.updateRestrictions();
        } else {
          scaledHeight = scaledWidth / cropParams.cropAspect;
        }
      } else {
        scaledWidth = widthPx / cropParams.cropScale;
        scaledHeight = scaledWidth / cropParams.cropAspect;
      }

      var canvas = options.canvas || document.createElement('canvas');
      canvas.width = scaledWidth;
      canvas.height = scaledHeight;
      var context = canvas.getContext('2d');
      var screenScale = scaledWidth / widthPx * cropParams.cropScale;
      var imgLeftPx = -cropParams.cropX * widthPx * screenScale;
      var imgTopPx = -cropParams.cropY * widthPx * screenScale;
      context.translate(imgLeftPx.toFixed(2), imgTopPx.toFixed(2));
      context.scale(screenScale, screenScale);
      context.rotate(cropParams.cropAngle / 180 * Math.PI);
      context.drawImage(image, 0, 0);
      var hasAlpha = false;

      for (var sx = 1; sx < ~~scaledWidth; sx += ~~((scaledWidth - 6) / 5)) {
        for (var sy = 1; sy < ~~scaledHeight; sy += ~~((scaledHeight - 6) / 5)) {
          var pixelData = context.getImageData(sx, sy, 1, 1);

          if (pixelData.data[3] < 200) {
            hasAlpha = true;
            break;
          }
        }

        if (hasAlpha) break;
      }

      options.hasAlpha = hasAlpha;
      return canvas;
    }
  }, {
    key: "getResizedImageUrl",
    value: function getResizedImageUrl(image, type, quality, options) {
      var canvas = AMCropper.getResizedCanvas(image, options);

      if (options.hasAlpha) {
        type = 'image/png';
      }

      if (typeof type !== 'string' && !(type instanceof String)) {
        type = undefined;
      }

      if (!quality || quality === '' || isNaN(quality)) {
        quality = undefined;
      }

      return canvas.toDataURL(type, quality);
    }
  }, {
    key: "rotateAndResize",
    value: function rotateAndResize(image, finished) {
      function handleIt() {
        var canvas = document.createElement('canvas');
        var canvas2 = document.createElement('canvas');
        var width = image.width;
        var height = image.height;
        var changed = false;

        if (width > 4096) {
          height *= 4096 / width;
          width = 4096;
          changed = true;
        }

        if (height > 4096) {
          width *= 4096 / height;
          height = 4096;
          changed = true;
        }

        canvas2.width = width;
        canvas2.height = height;
        var context = canvas2.getContext('2d');
        context.drawImage(image, 0, 0, width, height);
        context = null;
        image = null;

        if (this && this.exifdata && this.exifdata.Orientation) {
          if (this.exifdata.Orientation === 6) {
            canvas.width = height;
            canvas.height = width;
            context = canvas.getContext('2d');
            context.translate(height, 0);
            context.rotate(90 * Math.PI / 180);
            context.drawImage(canvas2, 0, 0, width, height);
            changed = true;
          } else if (this.exifdata.Orientation === 3) {
            canvas.width = width;
            canvas.height = height;
            context = canvas.getContext('2d');
            context.translate(width, height);
            context.rotate(180 * Math.PI / 180);
            context.drawImage(canvas2, 0, 0, width, height);
            changed = true;
          } else if (this.exifdata.Orientation === 8) {
            canvas.width = height;
            canvas.height = width;
            context = canvas.getContext('2d');
            context.translate(0, width);
            context.rotate(270 * Math.PI / 180);
            context.drawImage(canvas2, 0, 0, width, height);
            changed = true;
          } else {
            canvas = canvas2;
          }
        } else {
          canvas = canvas2;
        }

        context = null;
        canvas2 = null;

        if (changed) {
          finished(canvas);
        } else {
          finished();
        }
      }

      if (window.EXIF) {
        window.EXIF.getData(image, handleIt);
      } else {
        handleIt();
      }
    }
  }]);
  return AMCropper;
}();

AMCropper.CropParams = AMCropperParams;
AMCropper.checkerBoardImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC';
AMCropper.checkerBoardBackground = "url(".concat(AMCropper.checkerBoardImage, ")");
var _default = AMCropper;
exports["default"] = _default;